import { render, staticRenderFns } from "./DepartmentsSelectBox.vue?vue&type=template&id=084b3df3&scoped=true&"
import script from "./DepartmentsSelectBox.vue?vue&type=script&lang=js&"
export * from "./DepartmentsSelectBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "084b3df3",
  null
  
)

export default component.exports